import PropTypes from 'prop-types';

export function InformationIconComponent(props) {
  const fillColor = props.fill || '#13232A';
  if (props.hovered) {
    return (
      <svg
        style={props.style}
        className={props.className}
        width='20px'
        height='20px'
        viewBox='0 0 20 20'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
      >
        <g id='symbols' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g id='icon/-info/black-hover' fill={fillColor}>
            <g id='Page-1'>
              <path
                d='M10,0 C4.486,0 0,4.486 0,10 C0,15.514 4.486,20 10,20 C15.514,20 20,15.514 20,10 C20,4.486 15.514,0 10,0 M10,0.918 C15.008,0.918 19.082,4.992 19.082,10 C19.082,15.008 15.008,19.082 10,19.082 C4.992,19.082 0.918,15.008 0.918,10 C0.918,4.992 4.992,0.918 10,0.918'
                id='Fill-1'
              />
              <path
                d='M10.6514,6.8193 C10.4684,7.0023 10.2524,7.0923 10.0004,7.0923 C9.7484,7.0923 9.5314,7.0023 9.3494,6.8193 C9.1684,6.6373 9.0764,6.4213 9.0764,6.1693 C9.0764,5.9173 9.1684,5.6993 9.3494,5.5173 C9.5314,5.3363 9.7484,5.2443 10.0004,5.2443 C10.2524,5.2443 10.4684,5.3363 10.6514,5.5173 C10.8344,5.6993 10.9234,5.9173 10.9234,6.1693 C10.9234,6.4213 10.8344,6.6373 10.6514,6.8193 Z M9.3694,15.1843 L10.6304,15.1843 L10.6304,8.5483 L9.3694,8.5483 L9.3694,15.1843 Z M10.0004,2.1603 C5.6704,2.1603 2.1604,5.6703 2.1604,10.0003 C2.1604,14.3303 5.6704,17.8403 10.0004,17.8403 C14.3304,17.8403 17.8394,14.3303 17.8394,10.0003 C17.8394,5.6703 14.3304,2.1603 10.0004,2.1603 Z'
                id='Fill-3'
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }

  return (
    <svg
      style={props.style}
      className={props.className}
      width='20px'
      height='20px'
      viewBox='0 0 20 20'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g id='symbols' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='icon/information-black'>
          <g id='Group'>
            <text id='i' fontFamily='Avenir-Medium, Avenir' fontSize='14' fontWeight='400' fill={fillColor}>
              <tspan x='8' y='15'>
                i
              </tspan>
            </text>
            <rect id='Rectangle-6' stroke={fillColor} x='0.5' y='0.5' width='19' height='19' rx='9.5' />
          </g>
        </g>
      </g>
    </svg>
  );
}

InformationIconComponent.propTypes = {
  hovered: PropTypes.bool,
  fill: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  color: PropTypes.string,
};
